import { ApolloError } from '@apollo/client';
import { ClaimWeldError, ClaimApproveWeldError } from '@bechtel/types';

export type ClaimWeldErrorExt = ClaimWeldError | ClaimApproveWeldError | ApolloError;

export interface ClaimWeldErrorProps {
  error: ClaimWeldErrorExt;
  close: () => void;
}
